import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { ScheduleCalendarComponent } from '../schedule-calendar/schedule-calendar.component';
import { CustomFormComponent } from '@services/formBuilder/abstract-custom-form-field';

@Component({
  selector: 'app-schedule-calendar-button',
  template: `
    <ion-button
      [class.page-button]="buttonStyle !== 'icon-only'"
      color="secondary"
      [fill]="buttonStyle === 'icon-only' ? 'clear' : 'solid'"
      (click)="showCalendar($event)"
      [attr.title]="buttonStyle === 'icon-only' ? (buttonText | translate) : null">
      <ion-icon name="calendar-outline" [slot]="buttonStyle === 'icon-only' ? 'icon-only' : 'start'"></ion-icon>
      <span *ngIf="buttonStyle !== 'icon-only'">{{ buttonText | translate }}</span>
    </ion-button>
  `,
styles: [`
    ion-button.page-button {
      --border-radius: 4px;
    }
    ion-button[fill="clear"] {
      --padding-start: 8px;
      --padding-end: 8px;
    }
  `],
  standalone: false
})
export class ScheduleCalendarButtonComponent extends CustomFormComponent {
  // Single schedule mode (legacy)
  @Input() scheduleID: number;

  // Combined schedule mode (work days + days off)
  @Input() workDaysScheduleID: number;
  @Input() daysOffScheduleID: number;

  // Location for resolving effective schedules when using company defaults
  @Input() locationID: number;

  // Subject-specific entries (folder, asset, etc.)
  @Input() subjectType: string;
  @Input() subjectID: number;
  @Input() folderID: number;
  @Input() assetID: number;

  @Input() buttonText: string = 'WORK_SCHEDULE.View_Effective_Schedule';

  // Button display style: 'text' (default) shows icon + text, 'icon-only' shows just the icon
  @Input() buttonStyle: 'text' | 'icon-only' = 'text';

  // Required by CustomFormComponent for use in FormBuilderService customElement
  @Output() onChanged: EventEmitter<any> = new EventEmitter<any>();
  public required: boolean = false;

  constructor(private popoverController: PopoverController) {
    super();
  }

  async showCalendar(event: Event) {
    // Determine which props to pass based on inputs
    const componentProps: any = {};

    if (this.workDaysScheduleID !== undefined || this.daysOffScheduleID !== undefined) {
      // Combined mode: pass both schedule IDs
      componentProps.workDaysScheduleID = this.workDaysScheduleID;
      componentProps.daysOffScheduleID = this.daysOffScheduleID;
    } else if (this.scheduleID !== undefined) {
      // Legacy single schedule mode
      componentProps.scheduleID = this.scheduleID;
    }

    // Pass locationID for resolving effective schedules
    if (this.locationID && this.locationID > 0) {
      componentProps.locationID = this.locationID;
    }

    // Pass subject info for subject-specific entries
    if (this.subjectType && this.subjectID) {
      componentProps.subjectType = this.subjectType;
      componentProps.subjectID = this.subjectID;
    }
    if (this.folderID) {
      componentProps.folderID = this.folderID;
    }
    if (this.assetID) {
      componentProps.assetID = this.assetID;
    }

    const popover = await this.popoverController.create({
      component: ScheduleCalendarComponent,
      componentProps,
      event,
      cssClass: 'schedule-calendar-popover',
      side: 'bottom',
      alignment: 'start'
    });

    await popover.present();
  }
}
